export default "__VITE_ASSET__Dov8FmOl__"